export const MAX_ITEMS_WHEEL = 50;
